(() => {
// import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js'
window.addEventListener('load', async ()=>{});

})();
//# sourceMappingURL=main.js.map
